import { decodeJwt } from 'jose';
import type { JwtPayload } from '../model/auth.types';

// jose's decodeJwt does base64url + UTF-8 decoding correctly (unlike hand-rolled
// atob, which yields a Latin-1 "binary string" and mojibakes multi-byte chars —
// e.g. Vietnamese "Tân" → "TÃ¢n"). It only parses the payload, no signature
// verification — verification stays server-side, same as before.
export function decodeJwtPayload(token?: string): JwtPayload | null {
  if (!token) {
    return null;
  }

  try {
    return decodeJwt(token) as JwtPayload;
  } catch (error) {
    console.warn('Unable to decode JWT payload', error);
    return null;
  }
}

export function extractUserRoles(payload: JwtPayload | null): string[] {
  if (!payload) {
    return [];
  }

  const roleCollections = [payload.roles, payload.authorities, payload.permissions].filter(
    (collection): collection is string[] => Array.isArray(collection)
  );

  if (roleCollections.length) {
    return [...new Set(roleCollections.flat().map((role) => String(role).toLowerCase()))];
  }

  if (Array.isArray(payload.scope)) {
    return payload.scope.map((entry) => String(entry).toLowerCase());
  }

  if (typeof payload.scope === 'string') {
    return payload.scope
      .split(' ')
      .map((entry) => entry.trim().toLowerCase())
      .filter(Boolean);
  }

  return [];
}
